import { api } from './api';

export interface Client {
  id: number;
  name: string;
  company: string | null;
  contact_email: string | null;
  notes: string | null;
  status: string;
  created_by: number | null;
  created_at: string;
}

export const clientsApi = {
  list: (status?: string) =>
    api.get<Client[]>(`/clients${status ? `?status=${status}` : ''}`),

  create: (data: Partial<Client>) => api.post<Client>('/clients', data),

  update: (id: number, data: Partial<Client>) =>
    api.patch<Client>(`/clients/${id}`, data),

  archive: (id: number) => api.post<Client>(`/clients/${id}/archive`, {}),
};
